import authInterceptor from "../../AuthInterceptor";

export const StatusManagementAPI = {
  getTableList: () =>
    authInterceptor
      .get(`ranking-api/admin/statuses/`)
      .then((response) => response.data)
      .catch((error) => error.response),
  addStatus: (bodyData) =>
    authInterceptor
      .post(`ranking-api/admin/statuses/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  updateStatus: (id, bodyData) =>
    authInterceptor
      .put(`ranking-api/admin/statuses/${id}/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  deleteStatus: (id) =>
    authInterceptor
      .delete(`ranking-api/admin/statuses/${id}/`)
      .then((response) => response.data)
      .catch((error) => error.response),
};
